// pages/Create.tsx
import React from 'react';
import { useForm } from 'react-hook-form';
import CrudCreate from '~/components/CrudCreate';
import Layout from '~/components/Layout';
import IEquipment from '../interfaces/IEquipment';

export default function Create() {
  const { register, handleSubmit, control, setValue: setFormValue } = useForm<IEquipment>();
  const fields = [
    { name: 'name', type: 'string', placeholder: 'Equipment Name', required: true },
    { name: 'code', type: 'string', placeholder: 'Code', required: true },
    { name: 'serial_number', type: 'string', placeholder: 'Serial Number', required: true },
    { name: 'equipment_group_id', type: 'selectAutoComplete', model: 'equipment-group', placeholder: 'Equipment Group', required: true },
    { name: 'agency_id', type: 'selectAutoComplete', model: 'agency', placeholder: 'Agency:name', required: true },
    { name: 'warehouse_id', type: 'selectAutoComplete', model: 'warehouse', placeholder: 'Warehouse', required: true },
  ];

  return (
    <Layout marginLayout={true}>
      <CrudCreate
        model={'equipment'}
        fields={fields}
        register={register}
        handleSubmit={handleSubmit}
        control={control}
        messageSuccess={'Equipment successfully created!'}
        title={'Add equipment'}
        subheader={'Add equipment'}
        setFormValue={setFormValue}
      />
    </Layout>
  );
}
